import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["variant"];
import { LockedIcon } from 'foundations-assets';
import { IconContainer } from './IconContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const IconLock = _ref => {
  let {
      variant = 'disabled'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(IconContainer, Object.assign({}, rest, {
    variant: variant,
    children: /*#__PURE__*/_jsx(LockedIcon, {})
  }));
};
export const LockBadge = IconLock;